import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { FEATURES } from '../../account/api/getFeaturesForUserId';

export default function TaxNotificationBox() {
    return <div style={styles.container}>
        <WarningAmberIcon/>
        <span style={styles.text}>
            U.S. Customers: Beginning July 1, 2025 any recurring subscription will be subject to sales tax. This may
            increase the total amount you pay in the future and will be indicated on your future receipts.
        </span>
    </div>;
}

const styles = {
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        gap: 4,
        flex: '1 0 0',
        backgroundColor: 'blue',
        color: '#FFF',
        borderRadius: 4,
        padding: '14px 13px 14px 16px',
    },
    text: {
        fontFamily: 'Poppins',
        fontSize: 14,
        paddingLeft: 10
    }
}
